import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { Container as e, WhatsAppIcon as i, Title as l } from "./style.js";
import { DealAction as p } from "../../../types/Deal/index.js";
import { useTranslation as c } from "../../../hooks/useTranslation/index.js";
import { Whatsapp as m } from "@pelando/fontawesome/icons";
function T({ id: t, dispatch: r }) {
  const { t: o } = c("common");
  return /* @__PURE__ */ n(e, { onClick: () => {
    r({ type: p.CLICK_TO_SHARE, payload: { id: t } });
  }, children: [
    /* @__PURE__ */ a(
      i,
      {
        icon: m,
        "aria-label": o("deal-whatsapp-icon-aria-label")
      }
    ),
    /* @__PURE__ */ a(l, { children: o("deal-whatsapp-button") })
  ] });
}
export {
  T as ShareDealButton
};
